import { Injectable } from '@angular/core';
import { NEVER } from 'rxjs';
import type { Observable } from 'rxjs';

/**
 * `hunting-products.effects.ts`'s `watchCannesWifiConnection$` calls this service's
 * `watchDisconnect$` directly (independent of `CannesWifiConnectionService`) on the SSID
 * `MockCannesWifiConnectionService` fabricates — an SSID that never really exists. The real
 * implementation polls native WiFi state, so left unmocked it would run a live native WiFi watch
 * against a phantom network. Never emitting here keeps the whole device surface hermetic (no
 * native WiFi calls at all while the mock is active).
 */
@Injectable()
export class MockCannesWifiService {
  watchDisconnect$(_expectedSsid: string): Observable<void> {
    return NEVER;
  }

  generatePassphrase(): string {
    return 'MOCK-PASSPHRASE-4711';
  }

  isReusablePassphrase(passphrase: string | undefined): passphrase is string {
    return typeof passphrase === 'string' && passphrase.length > 0;
  }

  hasLocationPermission(): Promise<boolean> {
    return Promise.resolve(true);
  }

  requestLocationPermission(): Promise<void> {
    return Promise.resolve();
  }

  connectToCannesAp(_ssid: string, _passphrase?: string): Promise<void> {
    return Promise.resolve();
  }

  disconnectFromCannesAp(): Promise<void> {
    return Promise.resolve();
  }
}
